import type { Strategy } from '@/store/authStore';

const fireApi = {
  fire: {
    agent: '/api/agencies/agent/fire',
    agentWithDeals: '/api/agents/fire-process',
    represesAgentsDealsToAccept: '/api/users/repres/bookings/fire-process',
    represesAcceptAgentsDeals: '/api/represes/agent/fire-process/accept',
    byRole: (strategy: Strategy) => `/api/${ strategy }/fire_agent`,
    joinAgency: '/api/agents/fire-process/agency',
    createNewAgency: '/api/agents/fire-process/new-agency',
  },
};

export default fireApi;

export const fireApiConfig = fireApi.fire;
